export default{
  news:[
    {
      id: 0,
      title: 'Spuścizna Jana Gozdawy-Gołębiowskiego udostępniona w OSA',
      text: 'Zakończyliśmy realizację projektu obejmującego opracowanie, digitalizację i upowszechnienie kolekcji osobistej Jana Gozdawy-Gołębiowskiego (1925 – 2013). W jej skład wchodzą materiały dotyczące życia Jana Gozdawy-Gołębiowskiego, jego braci, również żołnierzy AK oraz materiały dokumentujące działania Armii Krajowej na terenie Obszaru Warszawskiego ',
      url: "/aktualnosci/spuscizna_jana_gozdawy_golebiowskiego",
      img: '/aktualnosci/spuscizna_jana_gozdawy_golebiowskiego.jpg'
    },
    {
      id: 1,
      title: 'Obchody 70. rocznicy operacji „Ostra Brama”',
      text: 'Siedemdziesiąt lat temu żołnierze Armii Krajowej podjęli walkę o Wilno, pragnąc wyzwolić je własnymi siłami z rąk niemieckich przed wejściem Armii Czerwonej, która wypierając Niemców nie niosła ze sobą wolności, lecz sowieckie zniewolenie. Opanowanie Wilna i wystąpienie wobec Sowietów przez władze cywilne i wojskowe Polskiego Państwa Podziemnego',
      url: "/aktualnosci/relacja_z_obchodow",
      img: '/aktualnosci/relacja_z_obchodow.jpg'
    },
    {
      id: 2,
      title: 'Uroczystosci w Wilnie oraz zbiórka darów na rzecz żołnierzy AK',
      text: 'W obchodach wezmą udział kombatanci – żołnierze Armii Krajowej zPolski, Białorusi i Litwy oraz członkowie Stowarzyszenia, nauczyciele wraz zuczniami i harcerzami z patriotycznych szkół w Bujwidzach, Wojdatach, Soleczniakach, Wilnie, Sejnach, Suwałkach, Augustowie, Białymstoku, Warszawie, Wołominie i Krakowie',
      url: "/aktualnosci/urocz_w_wilnie",
      img: '/aktualnosci/urocz_w_wilnie.jpg'
    },
    {
      id: 3,
      title: 'Odznaczenie dla gen. A. Krzyżanowskiego "Wilka"',
      text: 'Żołnierze Armii Krajowej Okręgu Wileńskiego i Nowogródzkiego na spotkaniu u Prezydenta Rzeczpospolitej dla wręczenia po śmierci odznaczenia dla gen. A. Krzyżanowskiego "Wilka"',
      url: "/aktualnosci/odzn_gen_krzyzanowski",
      img: '/aktualnosci/odzn_gen_krzyzanowski.jpg'
    },
    {
      id: 4,
      title: 'Zawieszenie i poświęcenie votum',
      text: 'W kwietniu 2011r. Prezes Okręgu Wileńskiego Światowego Związku Żołnierzy Armii Krajowej – Janusz Bohdanowicz – wziął udział w uroczystości poświęcenia nowej dzwonnicy przy kaplicy w Skorbucianach koło Wilna, gdzie znajduje się cmentarz żołnierzy 7 Wileńskiej Brygady AK, poległych w czasie II Wojny Światowej',
      url: "/aktualnosci/zawiesz_posw_votum",
      img: '/aktualnosci/zawiesz_posw_votum.jpg'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/models/aktualnosci.js